export const DEFAULT_SPEED = 8;

// The data attribute which may be defined on the elemenet in the following way:
// `<div class="pushin-scene" data-pushin-breakpoints="768,1440"></div>`.
export const PUSH_IN_BREAKPOINTS_DATA_ATTRIBUTE = 'pushinBreakpoints';

// The data attribute which may be defined on the elemenet in the following way:
// `<div data-pushin-speed="6"></div>`.
export const PUSH_IN_SPEED_DATA_ATTRIBUTE = 'pushinSpeed';

export const PUSH_IN_TO_DATA_ATTRIBUTE = 'pushinTo';
export const PUSH_IN_FROM_DATA_ATTRIBUTE = 'pushinFrom';

export const PUSH_IN_DEFAULT_BREAKPOINTS = [768, 1440, 1920];

export const PUSH_IN_LAYER_INDEX_ATTRIBUTE = 'data-pushin-layer-index';

export const PUSH_IN_DEFAULT_ASPECT_RATIO = [1, 2];

export const PUSH_IN_DEFAULT_TRANSITION_LENGTH = 200;

export const PUSH_IN_DEFAULT_LAYER_DEPTH = 1000;
